import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const reviewSlice = createSlice({
  name: "paymentSlice",
  initialState: {
    loading: false,
    allPayments: [],
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    getPayHistory: (state, action) => {
      state.allPayments = action.payload;
    },
  },
});

export const { getPayHistory, loading } = reviewSlice.actions;

export const getPaymentHistory = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_payment_history`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(getPayHistory(data?.data));
    dispatch(loading(false));
  } catch (error) {
    toast.error(error?.response?.data?.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export default reviewSlice.reducer;
